{
  "personalizedDestinations": {
    "title": "Destinations you might like"
  },
  "viewDetails": "View details",
  "moneyBackHighlight": {
    "title": "Full refund if you cancel in 24 hours",
    "description": "Easy online cancellation. No fees."
  },
  "modal": {
    "moneyBackHighlightTitle": "24-hour cancellation rule"
  }
}
